/**
 * Trần độ dài ghi chú nghiệp vụ của một nguồn, tính bằng ký tự.
 *
 * Đứng riêng một tệp vì HAI đường ghi vào ô ấy cần nó: ô nhập ở tab "Ghi chú
 * & thuật ngữ" (để hiện bộ đếm lúc gõ) và nút "Khai nhanh theo mẫu" ở màn Kết
 * nối (để chặn trước khi gọi máy chủ). Để hằng số này nằm trong một trong hai
 * component là buộc component kia import chéo vào một tệp UI.
 *
 * Phải khớp `GHI_CHU_TOI_DA` ở backend `tro-ly-ai` (port `replica.py`).
 * Hai bản sao thì trôi khỏi nhau, nhưng ngã hỏng lành: lệch cao thì máy chủ
 * trả 422 kèm thông báo rõ, lệch thấp thì giao diện chặn sớm hơn cần.
 *
 * ⚠️ Con số này là một KHOẢN CHI LẶP LẠI, không phải một giới hạn ô nhập:
 * ghi chú đi vào lời nhắc của MỌI câu hỏi trên nguồn. 4.000 ký tự ≈ 1.200
 * token. Muốn nới thì nới, nhưng nới vì "mẫu không vừa" là chữa triệu chứng —
 * lần trước triệu chứng ấy chỉ ra rằng một danh sách kiểm dành cho CON NGƯỜI
 * đang nằm trong khối gửi cho mô hình. Xem `MAU_KIEM_SAP_B1`.
 */
export const GHI_CHU_TOI_DA = 4000;
